import { TFPageContent, TFPageHeader } from '@tf/shared';
import { Icon } from '@tf/ui';
import { T } from '@tf/utils';
import { ProfilesTable } from '@/components/profiles/ProfilesTable';
import { AddProfileButton } from '@/components/shared';
import { useProfileGroupsSchemas } from '@/core/api/profiles';
import { appStore } from '@/core/stores';
import { AccountListRoute } from '@/routes/AccountListRoute';

export const ProfileRedirectRoute = () => {
	const { data: profileGroups, isLoading } = useProfileGroupsSchemas();
	const tenant = appStore.tenant?.get();

	if (isLoading) {
		return null;
	}

	if (profileGroups?.groups && profileGroups.groups.length > 0) {
		const firstGroup = profileGroups.groups[0];

		T.assertNotNullish(tenant, 'no tenant in appStore');

		return (
			<>
				<TFPageHeader tenant={tenant} title={firstGroup.label} toolbar={<AddProfileButton />} />
				<TFPageContent>
					<ProfilesTable
						filterByKinds={firstGroup.kinds}
						storageKeyPrefix={firstGroup.label.toLowerCase()}
						emptyStateIcon={<Icon.IconUsers />}
						emptyStateTitle={`No ${firstGroup.label.toLowerCase()} found`}
						searchPlaceholder={`Search by ${firstGroup.label.toLowerCase()} name`}
						columnLabels={{
							name: 'Name',
							type: 'Type',
							status: 'Status',
						}}
					/>
				</TFPageContent>
			</>
		);
	}

	return <AccountListRoute />;
};
